// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-tooltip--Dm591{position:relative !important;top:0;left:0}.error-tooltip--Dm591 .title--JZ7E6{margin-bottom:5px !important}", "",{"version":3,"sources":["webpack://./src/components/common/TableGrid/CustomComponents/AgGridCellRenderer/error-tooltip.module.scss"],"names":[],"mappings":"AAAA,sBACE,4BAAA,CACA,KAAA,CACA,MAAA,CAEA,oCACE,4BAAA","sourcesContent":[".error-tooltip {\n  position: relative !important;\n  top: 0;\n  left: 0;\n\n  .title {\n    margin-bottom: 5px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error-tooltip": "error-tooltip--Dm591",
	"title": "title--JZ7E6"
};
export default ___CSS_LOADER_EXPORT___;
